import { DialogueUIConfig, DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType, Window508Type } from "../CalmBaseScenario";
import Scenario5 from "./Scenario5";
import { NurseStationComputerSingleQustionUIConfig } from "../../components/ui/NurseStationComputerSingleQuestionUI";

export default class Scenario5Part3 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 0;
	chapterIds = {
		scenario5_3A_s9: 'CALM - Scenario 5 - 3A - Segment 9',
		scenario5_3A_s10: 'CALM - Scenario 5 - 3A - Segment 10',
		scenario5_1B_s11: 'CALM - Scenario 5 - 1B - Segment 11',
	}

	constructor(scenario: Scenario5, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario5/calm-scenario5-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario5.parts.level5Part3.id;
	}

	public start() {
		const context = this;
		context.segment1Step2Dialogue();

	}

	private segment1Step2Dialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.dialog(
			'CN-C06-S1-000b',
			[{
				text: 'We are going to have to delay the surgery until the morning. We do not have any access to interpreters during night shifts.',
				feedback: 'Although you chose another option, let\'s go ahead and look up the failicity\'s policies on interpreters before proceeding.',
				scoreType: ScoreType.Zero,
				isCorrect: false // Rank Zero
			}, {
				text: 'Call her husband. He can provide informal interpreter services over the phone.',
				feedback: 'Although you chose another option, let\'s go ahead and look up the failicity\'s policies on interpreters before proceeding.',
				scoreType: ScoreType.Zero,
				isCorrect: false // Rank Zero
			}, {
				text: 'Just have Mrs. Srisati sign the form. We will brief her after the procedure, in the morning.',
				feedback: 'Although you chose another option, let\'s go ahead and look up the failicity\'s policies on interpreters before proceeding.',
				scoreType: ScoreType.Zero,
				isCorrect: false // rank Zero
			}, {
				text: 'I need to look up our facility’s policies for interpreter services before proceeding.',
				scoreType: ScoreType.Best,
				isCorrect: true // Rank best_s
			}],
			(selectedOption: DialogueUIOptionConfig, config: DialogueUIConfig) => {
				context.scenario.evaluateAnswer_s(selectedOption, () => {
					context.segment3Step1GoToPC();
				}, () => {
					context.segment3Step1GoToPC();
					}
				)
				context.scenario.evaluateAnswerForSummative(selectedOption, {
					onOptionSelected: () => { },
					options: [
						{
							text: 'We are going to have to delay the surgery until the morning. We do not have any access to interpreters during night shifts.',							
							scoreType: ScoreType.Zero,
							isCorrect: false // Rank Zero
						}, {
							text: 'Call her husband. He can provide informal interpreter services over the phone.',							
							scoreType: ScoreType.Zero,
							isCorrect: false // Rank Zero
						}, {
							text: 'Just have Mrs. Srisati sign the form. We will brief her after the procedure, in the morning.',							
							scoreType: ScoreType.Zero,
							isCorrect: false // rank Zero
						}, {
							text: 'I need to look up our facility’s policies for interpreter services before proceeding.',
							scoreType: ScoreType.Best,
							isCorrect: true // Rank best_s
						}
					],
					aarScenarioID: 3,
					aarSectionID: 0,
					aarCollectionID: [config.selectedAnswer]
				}, () => { }, context.partIndx)
			})		
		this.scenario.updateObjective('Select your response to Ben')
	}

	private segment3Step1GoToPC(){
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('Use Nurse Station Computer to look up Interpreter Services Policies');
		context.playVideoChapter(context.chapterIds.scenario5_3A_s9, () => {
			context.segment3Step2UsePC();
		});
	}

	private segment3Step2UsePC() { // This interaction is just a scrollable text field with text		
		var context = this;
		context.scenario.update508Window(Window508Type.NurseStationComputerUI);
		const instanceId = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerUI, {
			reports: null,
			review: { 
				text:
					` 
					<p class="regular-description-font" style="margin: 0">
					LIMITED ENGLISH PROFICIENCY SERVICES<br /><br >
					<span style="color: rgb(222, 225, 156)">
					1. PURPOSE. To implement a Limited English Proficiency (LEP) program for telephonic language interpretation and on-site language interpretation at the VAMC, and establish the policy and responsibilities associated with this program. <br /><br />

					2. POLICY. It is the policy of this medical center that all Veterans receive equitable and the highest quality of health care obtainable. To this end, those Veterans with limited English proficiency shall not receive lesser healthcare resulting from a failure to effectively communicate VHA health care treatment options and benefits. <br /><br />

					3. ACTIONS/PROCEDURES.</span> <br /><br />

						a.Contact Interpreter Services. <br /><br />

						b. Local staff may provide interpretation services to help explain common or daily nursing care instructions. Local staff may not provide interpretation services for official medical forms requiring patient signature. <br /><br />

						c. If the need for telephonic interpreter services arises at the medical center, the healthcare provider should: <br /><br />

							1. When feasible and if not already done, bring the patient to a private area with a phone that has speakerphone options, and <br /><br />

							2. Follow the instructions provided in Attachment A.
					</p>
					`
			},
			reflects: null,
			onClosed: (config: NurseStationComputerUIConfig) => {
				context.scenario.update508Window(Window508Type.Main);
				context.scenario.gameManager.UiManager.destroyUIInstanceById(instanceId);
				context.segment3Step3Quiz();
			}
		})
	}

	private segment3Step3Quiz() {
		var context = this;
		var selectedAnswer = 0;
		context.scenario.destroyAllUIInstances();		
		context.scenario.update508Window(Window508Type.NurseStationComputerSingleQuestionUI);
		const instancedId = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerSingleQuestionUI, {
				title: 'When can local staff provide interpretation services?',
				isSummative: true,
				options: [
					{
						text: 'Only for common or daily nursing care instructions.',
						scoreType: ScoreType.Best,
						isCorrect: true, //Rank Best_S
						isSummative: true,
					},
					{
						text: 'Only for official medical forms.',
						scoreType: ScoreType.Zero,
						isSummative: true,
						isCorrect: false, //Rank Zero
					},
					{
						text: 'For all patient care needs and medical forms.',
						scoreType: ScoreType.Zero,
						isSummative: true,
						isCorrect: false, //Rank Zero
					},
					{
						text: 'Never.',
						scoreType: ScoreType.Zero,
						isSummative: true,
						isCorrect: false, //Rank Zero
					}
				],
				onChoiceSelected: (selectedOption: DialogueUIOptionConfig, selectedIndex:number) => {
					//context.scenario.evaluateAnswer(selectedOption, () => {}, context.partIndx);
					// context.scenario.evaluateAnswerForSummative(selectedOption, {
					// 	onOptionSelected: ()=> {},
					// 	aarScenarioID : 3,
					// 	aarSectionID : 1,
					// 	aarCollectionID: []
					// 	options:[
					// 		{
					// 			text: 'Only for common or daily nursing care instructions.',
					// 			scoreType: ScoreType.Best,
					// 			isCorrect: true, //Rank Best_S
					// 		},
					// 		{
					// 			text: 'Only for official medical forms.',
					// 			scoreType: ScoreType.Zero,
					// 			isCorrect: false, //Rank Zero
					// 		},
					// 		{
					// 			text: 'For all patient care needs and medical forms.',
					// 			scoreType: ScoreType.Zero,
					// 			isCorrect: false, //Rank Zero
					// 		},
					// 		{
					// 			text: 'Never.',
					// 			scoreType: ScoreType.Zero,
					// 			isCorrect: false, //Rank Zero								
					// 		}
					// 	],
					// }, () => { }, context.partIndx)					
					selectedAnswer = selectedIndex;
				},

				onClosed: (config: NurseStationComputerSingleQustionUIConfig) => {
					context.scenario.gameManager.UiManager.destroyUIInstanceById(instancedId);
					config.aarScenarioID = 3;
					config.aarSectionID = 1;					
					config.selectedOption = selectedAnswer;
					context.scenario.evaluateAnswerForSummativeNurseStationComputerSingleQuestion(config, () => {					
						context.segment4Step1ReturnToBen();
					});
				},
			})		
	}

	private segment4Step1ReturnToBen() {
		var context = this;
		context.playVideoChapter(context.chapterIds.scenario5_3A_s10, () => {
			context.segment4Step2Miranda();
		});
	}	

	private segment4Step2Miranda() {
		var context = this;
		context.playVideoChapter(context.chapterIds.scenario5_1B_s11, () => {
			context.onDone();
		});
	}	
}